import { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

const useLoadData = (apiEndpoint) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [data, setData] = useState([]);

    const token = useSelector((state) => state.user.admin.token);

    // Load data from api
    const loadData = () => {
        setIsLoading(true);

        const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY };
        AUTH_HEADER.Authorization += ":Bearer " + token;

        return axios
            .get(process.env.REACT_APP_API_URL + apiEndpoint, {
                headers: AUTH_HEADER
            })
            .then(response => {
                if (
                    response.status !== 200 ||
                    (response.data.status && response.data.status !== 200)
                ) {
                    setIsLoading(false);
                    setError(response.data.message)
                } else {
                    setIsLoading(false);
                    setData(response.data.items);
                }
            })
            .catch(err => {
                console.log(err);
                setIsLoading(false);
                setError(err);
            });
    }

    useEffect(() => {
        loadData();
    }, [])

    return [isLoading, error, data]
}

export default useLoadData;


// WEBPACK FOOTER //
// ./src/components/utils/DataTable/useLoadData.js